var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoRooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 116,
    viewBox: "0 0 120 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1997_73117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.763 56.2539L59.2065 93.6974L1.10181 114.359L21.763 56.2539Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3939 97.3244L19.9558 107.66L13.0908 110.096L7.29468 96.9607L10.8319 86.9883L13.5096 93.0599",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3939 97.3244L19.9558 107.66L13.0908 110.096L7.29468 96.9607L10.8319 86.9883L13.5096 93.0599",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9503 66.9766L33.7409 102.756L26.8759 105.191L14.4131 76.938L17.9503 66.9766Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9751 87.5487L47.526 97.8517L40.661 100.287L21.5205 56.9371L21.7629 56.2539L35.0191 69.4991L40.65 82.2815",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9751 87.5487L47.526 97.8517L40.661 100.287L21.5205 56.9371L21.7629 56.2539L35.0191 69.4991L40.65 82.2815",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1818 19.6936C34.1818 19.6936 41.73 41.4677 32.8154 58.239C32.8154 58.239 47.8127 44.3878 42.4793 19.2969L34.1818 19.6936Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4379 15.2305C59.4379 15.2305 59.1294 39.6712 40.3635 64.4646C40.3635 64.4646 62.909 46.7566 66.5233 17.3572L59.4379 15.2305Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7686 81.2804C95.7686 81.2804 73.9945 73.7322 57.2231 82.6468C57.2231 82.6468 71.0744 67.6496 96.1653 72.9829L95.7686 81.2804Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.231 56.0229C100.231 56.0229 75.7907 56.3314 50.9973 75.0973C50.9973 75.0973 68.7053 52.5518 98.1048 48.9375L100.231 56.0229Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.303 22.7656C82.303 22.7656 67.8457 49.1348 45.6418 69.7519C45.6418 69.7519 65.135 58.953 86.4793 26.9419L82.303 22.7656Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6143 8.92731C49.8182 10.7235 46.9201 10.7235 45.124 8.92731C43.3278 7.13117 43.3278 4.23309 45.124 2.43695C46.9201 0.640808 49.8182 0.640808 51.6143 2.43695C53.4105 4.23309 53.4105 7.13117 51.6143 8.92731Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.554 68.3843C115.758 70.1805 112.86 70.1805 111.063 68.3843C109.267 66.5882 109.267 63.6901 111.063 61.894C112.86 60.0978 115.758 60.0978 117.554 61.894C119.35 63.6901 119.35 66.5882 117.554 68.3843Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.741 36.8907C24.2727 36.8907 26.325 34.8384 26.325 32.3067C26.325 29.775 24.2727 27.7227 21.741 27.7227C19.2093 27.7227 17.157 29.775 17.157 32.3067C17.157 34.8384 19.2093 36.8907 21.741 36.8907Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4132 94.5132C68.617 96.3094 65.7189 96.3094 63.9228 94.5132C62.1266 92.7171 62.1266 89.819 63.9228 88.0229C65.7189 86.2267 68.617 86.2267 70.4132 88.0229C72.2093 89.819 72.2093 92.7171 70.4132 94.5132Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6832 15.7359C78.887 17.532 75.989 17.532 74.1928 15.7359C72.3967 13.9398 72.3967 11.0417 74.1928 9.24554C75.989 7.4494 78.887 7.4494 80.6832 9.24554C82.4793 11.0417 82.4793 13.9398 80.6832 15.7359Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3443 43.1393C90.9814 43.1393 92.3085 41.8122 92.3085 40.1751C92.3085 38.538 90.9814 37.2109 89.3443 37.2109C87.7072 37.2109 86.3801 38.538 86.3801 40.1751C86.3801 41.8122 87.7072 43.1393 89.3443 43.1393Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7851 93.8637C88.6281 95.0207 86.7548 95.0207 85.5977 93.8637C84.4407 92.7067 84.4407 90.8334 85.5977 89.6764C86.7548 88.5193 88.6281 88.5193 89.7851 89.6764C90.9421 90.8334 90.9421 92.7067 89.7851 93.8637Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3775 68.0221C95.0146 68.0221 96.3417 66.695 96.3417 65.0579C96.3417 63.4209 95.0146 62.0938 93.3775 62.0938C91.7404 62.0938 90.4133 63.4209 90.4133 65.0579C90.4133 66.695 91.7404 68.0221 93.3775 68.0221Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.408 39.9323C110.045 39.9323 111.372 38.6052 111.372 36.9681C111.372 35.331 110.045 34.0039 108.408 34.0039C106.771 34.0039 105.444 35.331 105.444 36.9681C105.444 38.6052 106.771 39.9323 108.408 39.9323Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1997_73117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 115.46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRooms);
export default __webpack_public_path__ + "static/media/noRooms.8495380752a1d5faae0140ff9b1b66d1.svg";
export { ForwardRef as ReactComponent };